function getSliceArr (arr, num) {
  const newarr = []
  if (arr.length > 0) {
    for (let i = 0; i < arr.length; i += num) {
      newarr.push(arr.slice(i, i + num))
    }
  }
  return newarr
}

export {
  getSliceArr
}
